<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'logs',
})
</script>
<template>
<a-card title="日志">
   <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
  </lanseed-form-only>
  <a-table rowKey="ID"  :row-selection="rowselection"  :columns="columns" :dataSource="dataSource" :pagination="page" @change="pageChange">
    <template #title>
      <div v-if="rowselection.selectedRowKeys.length>0"  class="padding flex align-center" style="width: 100%;">
        <span class="text-gray">共选择了<span class="text-primary text-bold padding-lr-sm">{{ rowselection.selectedRowKeys.length }}</span>条数据</span>
        <a-button type="primary" size="small" class="margin-left" @click="onDel">
        <DeleteOutlined />  删除</a-button>
      </div>
    </template>
  </a-table>
</a-card>
</template>
<script setup lang="ts" name="logs">
import api from '@/utils/http/service'
import { onMounted,ref,getCurrentInstance } from 'vue'
import {DeleteOutlined} from   '@ant-design/icons-vue'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import {message} from 'ant-design-vue'
const auth:any=api.auth()
console.info('auth',auth)
const dataSource=ref<Array<any>>([])
const selectedIDS=ref<Array<any>>([])
const loading=ref<Boolean>(false)
const page=ref<Record<string,string>>({
  current:1,
  pageSize:10,
  total:0
})
const columns:Array<any>=[
  {title:'日志',dataIndex:'title'},
  {title:'时间',dataIndex:'retime'},
  {title:'操作',key:'action',},
]
const searchVal:Record=ref({
  keyword:''
})
const searchRule:Record=ref({
  keyword:{name:'关键字'},
})
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const getDataList=():void=>{
  loading.value = true
  api.logs.list({ pageIndex: page.value.current, pageSize: page.value.pageSize,...searchVal.value }).then(res => {
        loading.value = false
        if (res.state == 1) {
          let r = res.data
          page.value.current=r.pageIndex
          page.value.total=r.records
          dataSource.value = r.data
        }
      })
}
const search=(e):void=>{
  searchVal.value=e
  page.value.current=1
  getDataList()
}
const pageChange=(e):void=>{
  page.value.current=e.current
  page.value.pageSize=e.pageSize
  getDataList()
}
const onDel=(item:any,index:number):void=>{
  api.logs.dels(rowselection.value.selectedRowKeys).then(res => {
          if (res.state == 1) {
            message.success(res.message)
            getDataList()
          }
        })
}
onMounted(()=>{
  getDataList()
})
</script>
